import { KibButtonNew } from '@chewy/kib-controls-react';

import { useSheetContext } from '@/providers/SheetProvider';

import styles from './FreeTrialButton.module.scss';

interface Props {
  displayText: string;
}

export const FreeTrialButton = ({ displayText, ...rest }: Props) => {
  const { openSheet } = useSheetContext();
  return (
    <KibButtonNew {...rest} className={styles.btn} onClick={() => openSheet()}>
      <span className={styles.displayText}>{displayText}</span>
    </KibButtonNew>
  );
};
